import {
  DefaultApi,
  ServerConfiguration,
  servers,
  createConfiguration,
} from "@vviinn/user-managment-client-ts";
import { createBearerAuth } from "./bearer";
import { isProduction } from "../helpers";
import { customBffUrl } from "../helpers/env/customBffUrl";

const SERVER_INDEX = isProduction ? 0 : 1;
const baseServer = customBffUrl
  ? new ServerConfiguration(customBffUrl, {})
  : servers[SERVER_INDEX];

export const createApi = (token: string) => {
  const authMethods = createBearerAuth(token);

  return new DefaultApi(createConfiguration({ baseServer, authMethods }));
};

export const createAnonymousApi = () =>
  new DefaultApi(createConfiguration({ baseServer }));
